import { Company } from 'app/core/company/company.types';
import { BaseModel } from '../../modules/admin/common/table/base-model';

export interface User extends BaseModel
{
    name: string;
    surname: string;
    email: string;
    telephone: string;
    imageURL?: string;
    status?: string;
    language?: string;
    companyId?: number;
    companyName?: string;
    lastSelectorLoginDatetime: Date;
    lastDashboardLoginDatetime: Date;
    requiredActions?: string[];
    createdAt: Date;

    /**
     * List of companies that the user is enrolled in.
     * The user field `companyId` matches the current selected company in this list.
     */
    companies: Company[];
}

// user-update-me.type.ts
export interface UserUpdateMe {
    name: string;
    surname: string;
    telephone: string;
  }

  // user-update-detail.type.ts
  export interface UserUpdateDetail {
    name: string;
    surname: string;
    telephone: string;
    company: {
      id: number;
      roleId: number;
      active: boolean;
    };
  }

export const InvalidUser: User = { id: 0, name: '', surname: '', email: '', companies: [], telephone: '', lastSelectorLoginDatetime: null, lastDashboardLoginDatetime: null, createdAt: null }
